var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOkColor = function SvgOkColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.001,
    y: 0.064,
    fill: "#EE8208",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ok-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.43,
    y: 1.492,
    fill: "#EE8208",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ok-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.002 4.35a2.95 2.95 0 0 0-2.95 2.95 2.95 2.95 0 0 0 2.95 2.948 2.95 2.95 0 0 0 2.95-2.948 2.95 2.95 0 0 0-2.95-2.95m0 1.728a1.222 1.222 0 0 1 .863 2.084 1.223 1.223 0 0 1-1.726 0 1.223 1.223 0 0 1 0-1.725c.23-.23.54-.358.864-.358zM7.529 10.35a.864.864 0 0 0-.433 1.595 5.5 5.5 0 0 0 1.713.71L7.16 14.302a.864.864 0 0 0 1.222 1.222l1.62-1.62 1.621 1.62a.864.864 0 1 0 1.221-1.222l-1.648-1.648a5.5 5.5 0 0 0 1.712-.71.864.864 0 1 0-.92-1.463 3.75 3.75 0 0 1-3.971 0 .86.86 0 0 0-.488-.132"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ok-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.43 1.492h17.143v17.143H1.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ok-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.288 4.35h11.429v11.429H4.287z"
  })))));
};
export default SvgOkColor;